<template>
  <div class="auto_css" id="myElement">
    <div class="section1 section" id="section1">
      <img class="aboutbg1 pc" :src="require('@/assets/img/gamebg1.png')" />
      <img class="aboutbg1 h5" :src="require('@/assets/imgh5/gamebg1.png')" />

      <div class="top-font top-font1">加入</div>
      <div class="ct-font">
        <div>JIUWAN GAMES</div>
      </div>
      <div class="top-font top-font2">我们</div>
    </div>
    <div class="section2 section" id="section2">
      <img class="aboutbg2 pc" :src="require('@/assets/img/joinbg2.png')" />
      <!-- <img class="aboutbg2 h5" :src="require('@/assets/imgh5/gamebg2.png')" /> -->
      <div class="title pc">职位列表({{ tableList.length || 0 }})</div>
      <div class="contain">
        <div class="none-tip" v-if="tableList.length == 0">暂无数据~</div>
        <!-- pc -->
        <div
          v-for="(item, index) in showPcList"
          :key="index"
          @click="hanleGoDetail(item)"
          class="join-item pc"
        >
          <div class="join-name">{{ item.job_name }}</div>
          <div class="join-detail">
            <span>{{ item.job_address }}</span
            ><span class="space">|</span> <span>{{ item.job_type }}</span
            ><span class="space">|</span>
            <span>{{ item.job_attr }}</span>
          </div>
        </div>
        <!-- 下方切换按钮 -->
        <div class="swiper-btn">
          <img
            class="s-btn prev pc"
            :class="pcPage == 1 ? 'noneGo' : ''"
            :src="require('@/assets/img/left.png')"
            @click="handlePrev"
          />
          <img class="line1 pc" :src="require('@/assets/img/line1.png')" />
          <img
            class="s-btn next pc"
            :class="pcPage == totalPage ? 'noneGo' : ''"
            :src="require('@/assets/img/right.png')"
            @click="handleNext"
          />
        </div>

        <!-- h5  -->
        <div class="title h5">职位列表({{ tableList.length || 0 }})</div>
        <div
          v-for="(item, index) in tableList"
          :key="index"
          @click="hanleGoDetail(item)"
          class="join-item h5"
        >
          <div class="join-name">{{ item.job_name }}</div>
          <div class="join-detail">
            <span>{{ item.job_address }}</span
            ><span class="space">|</span> <span>{{ item.job_type }}</span
            ><span class="space">|</span>
            <span>{{ item.job_attr }}</span>
          </div>
        </div>
      </div>
    </div>

    <!-- 详情弹窗 -->
    <div class="detail-contain" v-if="showDiv == 2">
      <div class="top-w">
        <div class="top-close">
          <img
            class="close-icon"
            @click="handleBack"
            :src="require('@/assets/img/close.png')"
          />
        </div>
        <div class="name-div">
          <div class="join-name">{{ detail.job_name }}</div>
          <div class="join-detail">
            <span>{{ detail.job_address }}</span
            ><span class="space">|</span> <span>{{ detail.job_type }}</span
            ><span class="space">|</span>
            <span>{{ detail.job_attr }}</span>
          </div>
        </div>
        <div class="detail-text">
          <div class="detail-title">工作职责</div>
          <div class="detail-font" v-html="detail.job_desc"></div>
          <div class="detail-title">任职要求</div>
          <div class="detail-font" v-html="detail.job_request"></div>
        </div>
      </div>
      <div class="bottom-h">简历请投递：{{ detail.job_tel }}</div>
    </div>
  </div>
</template>
  
  <script setup>
import { ref, onMounted, onUnmounted, getCurrentInstance } from "vue";
import { useStore } from "vuex";
const store = useStore();
store.commit("setLoad", true);
const { proxy } = getCurrentInstance();
// 搜索
// pc展示的游戏列表4个
const pcPage = ref(1);
const totalPage = ref(1);
const showDiv = ref(1);
const showPcList = ref([]);
// pc展示哪些游戏
const tableList = ref([]);
const webId = ref();
console.log(window.location.host);
// 详情
const detail = ref();
// 初始化
const initData = async () => {
  let params = {
    host: window.location.host, //"www.love9w.com",
  };
  proxy.$axios.post("/Index/initData", params).then(async (res) => {
    if (res.code == 200) {
      webId.value = res.data.company_id;
      getJoinList();
    }
  });
};
initData();
// 获取招聘列表
const getJoinList = () => {
  let params = {
    company_id: webId.value,
  };
  proxy.$axios.post("/Index/getJobs", params).then(async (res) => {
    if (res.code == 200) {
      tableList.value = res.data;
      totalPage.value = Math.ceil(tableList.value.length / 6);
      getPcList();
    }
  });
};
const getPcList = () => {
  let list = [];
  if (tableList.value[(pcPage.value - 1) * 6]) {
    list.push(tableList.value[(pcPage.value - 1) * 6]);
  }
  if (tableList.value[(pcPage.value - 1) * 6 + 1]) {
    list.push(tableList.value[(pcPage.value - 1) * 6 + 1]);
  }
  if (tableList.value[(pcPage.value - 1) * 6 + 2]) {
    list.push(tableList.value[(pcPage.value - 1) * 6 + 2]);
  }
  if (tableList.value[(pcPage.value - 1) * 6 + 3]) {
    list.push(tableList.value[(pcPage.value - 1) * 6 + 3]);
  }
  if (tableList.value[(pcPage.value - 1) * 6 + 4]) {
    list.push(tableList.value[(pcPage.value - 1) * 6 + 4]);
  }
  if (tableList.value[(pcPage.value - 1) * 6 + 5]) {
    list.push(tableList.value[(pcPage.value - 1) * 6 + 5]);
  }
  showPcList.value = list;
};
// pc下方按钮点击
const handlePrev = () => {
  if (pcPage.value == 1) return;
  pcPage.value = pcPage.value - 1;
  getPcList();
};
const handleNext = () => {
  if (pcPage.value == totalPage.value) return;
  pcPage.value = pcPage.value + 1;
  getPcList();
};
// 查看详情
const hanleGoDetail = (item) => {
  detail.value = item;
  showDiv.value = 2;
};
const handleBack = () => {
  showDiv.value = 1;
};
onMounted(() => {
  store.commit("setLoad", false);
});
onUnmounted(() => {});
</script>
<style src="./join.css" scoped></style>
<style scoped>
</style>
  